<template>
  <load-component v-if="!store.state.loaded"></load-component>
  <v-app v-else class="bg-white">

    <v-app-bar>
      <v-container>
        <v-row justify="start" align="center">
          <v-col cols="9">
            <v-text-field
                v-model="search_query"
                :clearable="true"
                inputmode="search"
                @keyup.enter="on_search = true"
                @focus="on_search = true"
                density="comfortable"
                placeholder="Найти"
                hide-details="true"
                prepend-inner-icon="mdi-magnify"
                rounded
                bg-color="#EFF1F3"
                color="#7C7E82"
                theme="dark"
                variant="outlined"
                class="no-border"
                flat
            >
            </v-text-field>
          </v-col>
          <v-col v-if="on_search" cols="2">
            <v-btn @click="on_search = false" class="text-none" color="teal" variant="text">
              <div class="roboto-medium">Отменить</div>
            </v-btn>
          </v-col>
          <v-spacer v-if="!on_search"></v-spacer>
          <v-col v-if="!on_search" cols="2">
            <v-btn @click="pushToCartPage" icon="mdi-shopping-outline">
            </v-btn>
          </v-col>

        </v-row>
      </v-container>
    </v-app-bar>
    <div class="content" v-if="on_search">
      <v-sheet height="100px"></v-sheet>
      <v-row no-gutters justify="space-evenly" align="center">
        <v-col class="mx-1" cols="auto">
          <v-chip-group v-model="gender">
            <v-chip variant="tonal" color="teal" v-for="g in genders" :key="g">
              {{ g }}
            </v-chip>
          </v-chip-group>

        </v-col>
      </v-row>
      <v-container>

        <v-list v-if="filteredBrands.length">
          <v-list-item
              @click="search(brand)"
              v-for="(brand, index) in filteredBrands.slice(0, 5)"
              :key="index"
          >
            {{ brand }}
          </v-list-item>
        </v-list>
      </v-container>
    </div>
    <div class="content" v-else>
      <v-sheet height="60px"></v-sheet>

      <v-container>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="6" v-for="product in store.state.products" :key="product">
            <v-card variant="flat" rounded="xl" class="text-center">
              <v-card :ripple="false" variant="text">
                <v-card-actions  height="400px">
                  <v-row>
                    <v-col cols="9" @click="redirectToProductPage(product.spu_id)">
                      <v-img height="150px" :src="product.logo_url"></v-img>
                    </v-col>

                    <v-col cols="2">
                      <div v-if="store.state.wishlist.includes(product.spu_id)">
                        <v-btn :ripple="false" variant="text" color="red" icon="mdi-heart" @click="removeFromWishlist(product.spuId)">
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-btn :ripple="false"
                               variant="text"
                               color="black"
                               icon="mdi-heart-outline"
                               @click="addToWishlist(product.spu_id, product)">
                        </v-btn>
                      </div>
                    </v-col>
                   </v-row>
                </v-card-actions>
                <v-card-text @click="redirectToProductPage(product.spu_id)" height="400px">
                  <h6>{{product.brand_name.slice(0, 17)}}</h6>
                  <div style="font-size: 12px" v-if="product.title.length > 25">
                    {{product.title.slice(0, 25)}}...
                  </div>
                  <div style="font-size: 12px" v-else>
                    {{product.title.slice(0, 25)}}
                  </div>

                  <v-sheet height="10px"></v-sheet>
                  <b style="font-size: 12px">{{product.price}} RUB</b>
                </v-card-text>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <hr>
      <v-container>
        <v-pagination
            size="small"
            v-model="current_page"
            :length="per_page"
            @update:modelValue="onPageChange"
        ></v-pagination>
      </v-container>
      <v-sheet height="80px"></v-sheet>
    </div>
    <bottom-nav-component btn_1_color="black" >
<!--      <template v-slot:button>-->
<!--        <v-col cols="10" class="mb-3 mt-1 px-3">-->
<!--          <v-card  class="border-12" color="#F31549" variant="flat" width="100%">-->
<!--            <v-card-item class="text-center align-center" style="font-size: 16px">-->
<!--              <b>{{ store.state.text[lang].home.check_btn }}</b> <v-icon size="x-small">mdi-star-four-points</v-icon> <b>1</b>-->
<!--            </v-card-item>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--        <v-divider style="background: black; color: black; margin-bottom: 5px; margin-top: 0"></v-divider>-->
<!--      </template>-->
    </bottom-nav-component>


  </v-app>

</template>

<script>
import axios from "axios";
import store from "../store";
import BottomNavComponent from "@/components/BottomNavComponent.vue";
import LoadComponent from "@/components/LoadComponent.vue";

export default {
  name: "HomePage",
  computed: {
    store() {
      return store
    },
    filteredBrands() {
      return this.brands.filter(brand =>
          brand.toLowerCase().includes(this.search_query.toLowerCase())
      );
    },
  },
  components: {
    BottomNavComponent,
    LoadComponent
  },
  data: () => ({

    brands: ["Nike", "Tom Ford", "Adidas", "Tommy Hilfiger", "Puma", "Reebok", "Ozweego"],
    search_query: "",
    keyword: "string",
    on_search: false,
    wishlist: [],
    wishlist_products: [],
    genders: ["Унисекс", "Мужское", "Женское", "Детское"],
    gender: 0,
    fitId: [],
    current_page: 1,
    per_page: 6,
    info_items: ["./img_9.webp", "./img_10.webp"],
  }),
  mounted() {
    window.Telegram.WebApp.expand()
    window.Telegram.WebApp.BackButton.hide()
    window.Telegram.WebApp.MainButton.hide()
    window.Telegram.WebApp.disableVerticalSwipes()
    window.Telegram.WebApp.ready()

    this.checkInitData({_auth: window.Telegram.WebApp.initData})
    this.$store.commit("setStateProperty", {
      property: "loaded", value: false
    })

    if (this.$route.query.page) {
      this.current_page = parseInt(this.$route.query.page)
    }

    if (this.$route.query.keyword) {
      this.search_query = this.$route.query.keyword
      this.getProductsFilter()
    }
    else if (store.state.products.length == 1) {
      this.getProducts()
    }
    else {
      this.$store.commit("setStateProperty", {
        property: "loaded", value: true
      })
    }
  },
  beforeUnmount () {
  },
  methods: {
    onPageChange() {
      this.$store.commit("setStateProperty", {
        property: "loaded", value: false
      })
      this.$router.push({ path: '/', query: {page: this.current_page, keyword: this.keyword}})

      if (this.keyword != "string") {
        this.getProductsFilter()
      } else {
        this.getProducts()
      }
    },
    checkInitData(data) {
      axios.post('api/v1/check-init-data/', data)
          .then(response => {
            this.$store.commit("setStateProperty", {
              property: "user", value: response.data.user
            })
          })
          .catch(error => {
            console.error(error);
          });
    },
    // loadData() {
    //   this.getProducts()
    //   this.$store.commit("setStateProperty", {
    //     property: "loaded", value: true
    //   })
    //   window.Telegram.WebApp.ready()
    // },
    getProductsFilter() {
      this.keyword = this.search_query
      this.fitId = []
      this.fitId.push(this.gender+1)
      axios.post('api/v2/products/', {
          keyword: this.keyword,
          limit: this.per_page,
          page: this.current_page-1,
          fitId: this.fitId,
      }).then(response => {
        this.$store.commit("setStateProperty", {
          property: "loaded", value: true
        })
        this.$store.commit("setStateProperty", {
          property: "products", value: response.data
        })
      }).catch(error => {
          console.error(error);
        });

    },
    getProducts() {
      axios.post('api/v2/products/', {
        keyword: "string",
        limit: this.per_page,
        page: this.current_page-1,
        fitId: this.fitId,
      }).then(response => {
          this.$store.commit("setStateProperty", {
            property: "loaded", value: true
          })
        console.log(response.data)
          this.$store.commit("setStateProperty", {
            property: "products", value: response.data
          })
        }).catch(error => {
          console.error(error);
        });
    },
    redirectToProductPage(product_id) {
      this.$router.push({ name: 'Product', query: {
        product_id: product_id,
      }});
    },
    pushToCartPage() {
      this.$router.push({ name: 'Cart',});
    },
    search(data) {
      this.$store.commit("setStateProperty", {
        property: "loaded", value: false
      })
      this.on_search = false
      this.search_query = data
      this.getProductsFilter()
      this.current_page = 1
      this.$router.push({ name: 'Home', query: {
          keyword: this.$route.query.keyword,
          page: 1
        }});
    },
    addToWishlist(spuId, product) {
      this.wishlist.push(spuId)
      this.$store.commit("setStateProperty", {
        property: "wishlist", value: this.wishlist
      })
      this.wishlist_products.push(product)
      localStorage.setItem('wishlist', JSON.stringify(this.wishlist_products))
    },
    removeFromWishlist(spuId) {
      this.wishlist = this.wishlist.filter(item => item !== spuId);
      this.$store.commit("setStateProperty", {
        property: "wishlist", value: this.wishlist
      })

      this.wishlist_products = this.wishlist_products.filter(item => item.spuId !== spuId);
      localStorage.setItem('wishlist', JSON.stringify(this.wishlist_products))
    }
  }
}
</script>

<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

html, body {
  font-family: 'SF Pro', sans-serif !important;
  color: black;
  background: white !important;
  touch-action: manipulation !important;
}

:deep(.no-border .v-field) {
  border: none !important;
  box-shadow: none !important;
}

.pre-subtitle {
  white-space: pre-line !important;
}

</style>